import {StoreState} from '@/app/store';

export const selectDefaultLocationConfigShown = (state: StoreState) => state.ui.defaultLocationConfigShown;
